export const getPeriod = (
  isDeployed: boolean,
  privateStart: string | undefined,
  privateEnd: string,
) => {
  const now = new Date().getTime()

  if (!isDeployed) return 'comingSoon'
  if (!privateStart) return 'comingSoon'

  let start = new Date(privateStart).getTime() / 1000
  let end = new Date(privateEnd).getTime() / 1000

  start *= 1000
  end *= 1000

  const isOver = now > end
  if (isOver) return 'completed'

  const isUpcoming = now < start
  if (isUpcoming) return 'upcoming'

  const isLive = now > start && now < end
  return isLive ? 'public' : 'waiting'
}
